import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import BasicPanel from './Basic/BasicPanel';
import BillingPanel from './Billing/BillingPanel';
import FilterTabs from '../common/FilterTabs'
import Header from '../common/Header';
import AccountSettingHeader from './AccountSettingHeader';
import CreateChildAccountDialog from './dialogs/CreateChildAccountDialog';
import ChildAccountSetting from './ChildAccountSetting';
import ChildAccountAuthoritySetting from './ChildAccountAuthoritySetting';
import IntegrationPanel from './Integration/IntegrationPanel';
import NotificationBar from '../Parts/NotificationBar.jsx'
import PlanPanel from './Plan/PlanPanel';
import Loader from '../Parts/Loader';
import Wrapper from '../common/Wrapper';
import PlanDialog from '../SendLetter/dialogs/PlanDialog';
import { AccountSettingDirectory, ChildAccountSettingDirectory } from "../../constants/ComponentTypes";

const triple = 3;
const styles = theme => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },

  childContent: {
    width: '100%',
  },

  content: {
    padding: theme.spacing.unit * triple,
    overflowY: 'initial',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'start',
    width: '80%',
    paddingBottom: 108,
  },

  ownerContent: {
    width: '100%',
    padding: '25px 0px 0px 0px',
  },

  otherContent: {
    paddingTop: 50,
  }
});

class AccountSetting extends React.Component {
  componentWillMount() {
    this.props.getUserInfo();
    this.props.getSenders();
    this.props.getOrderContacts();
    this.props.getUserMails();

    let { routerInfo } = this.props;
    if (routerInfo && (
      routerInfo.pathname === ChildAccountSettingDirectory.ACCOUNT_LIST.path ||
      routerInfo.pathname === ChildAccountSettingDirectory.AUTHORITY.path ||
      routerInfo.pathname === ChildAccountSettingDirectory.OWNER.path)) {
      this.props.getChildUsers();
    }

    if (routerInfo && routerInfo.state && typeof routerInfo.state.initValue === 'object') {
      let initValue = routerInfo.state.initValue;
      for (let p in initValue) {
        if (this.state.hasOwnProperty(p)) {
          this.setState({ [p]: initValue[p] })
        }
      }
    }

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      if (this.props.childAccountType === ChildAccountSettingDirectory.ACCOUNT_LIST.name) {
        this.props.getChildUserById(this.props.match.params.id)
      }
    }

    this.setState({
      tab: this.props.type,
      childAccountTab: this.props.childAccountType
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.message && nextProps.message !== '') {
      this.displayNotification(nextProps.message, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== '') {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== '') {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    if (this.props.match.params.id !== nextProps.match.params.id && nextProps.match.params.id) {
      if (nextProps.childAccountType === ChildAccountSettingDirectory.ACCOUNT_LIST.name) {
        this.props.getChildUserById(nextProps.match.params.id)
      }
    }

    if (this.props.type !== nextProps.type) {
      this.setState({
        tab: nextProps.type,
        childAccountTab: ChildAccountSettingDirectory.OWNER.name,
      })
    }
    if (this.props.childAccountType !== nextProps.childAccountType) {
      this.setState({
        childAccountTab: nextProps.childAccountType
      })
    }

    if ((this.props.isDeletingChildUser && nextProps.isDeletingChildUser === false) ||
      (this.props.isSavingChildUser && nextProps.isSavingChildUser === false)) {
      this.props.getChildUsers();
    }
  }

  state = {
    tab: AccountSettingDirectory.GENERAL.value,
    childAccountTab: this.props.childAccountType,
    showNotification: false,
    showPlanDialog: false,
    showCreateChildAccountDialog: false,
    message: '',
    messageType: 'success',
  }

  handleTabClicked = (value) => {
    // if react router contains initial tab/dialog values on mounting the component,
    // clear the data when tabs are clicked
    let { routerInfo } = this.props;
    if (routerInfo && routerInfo.state && typeof routerInfo.state.initValue === 'object') {
      this.props.updateRouterState({})
    }

    let directory = Object.values(AccountSettingDirectory).find(item => item.value === value);
    this.props.goTo(directory.path);
  }

  toggleCreateChildAccountDialog = () => {
    this.setState({ showCreateChildAccountDialog: !this.state.showCreateChildAccountDialog });
  }

  togglePlanDialog = () => {
    this.setState({ showPlanDialog: !this.state.showPlanDialog });
  }

  toggleNotification = () => {
    this.setState({ showNotification: !this.state.showNotification });
  };

  displayNotification = (message, type = "success") => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 1000, top: 10, width: '99%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={this.toggleNotification}
          autoClose={true}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : '100%',
          }}
        >
        </NotificationBar>
      </div>
    );
  };

  renderPlanDialog = () => {
    if (this.state.showPlanDialog) {
      return (
        <PlanDialog
          isOpen={this.state.showPlanDialog}
          toggleDialog={this.togglePlanDialog}
        />
      )
    }
  }

  renderCreateChildAccountDialog = () => {
    return (
      <CreateChildAccountDialog
        user={this.props.user}
        title={'新規アカウントを追加'}
        isOpen={this.state.showCreateChildAccountDialog}
        toggleDialog={this.toggleCreateChildAccountDialog}
        postChildUser={this.props.postChildUser}
        isSaving={this.props.isSavingChildUser}
        error={this.props.error}
      />
    )
  }

  renderChildAccountContent = () => {
    const { user, routerInfo, childUser } = this.props;
    if (this.state.childAccountTab === ChildAccountSettingDirectory.ACCOUNT_LIST.name) {
      if (!!routerInfo && !!routerInfo.state && routerInfo.state.child_account_id) {
        return (
          <BasicPanel
            user={user}
            childUser={childUser}
            setUserInfo={this.props.setUserInfo}
            deleteAccount={this.props.deleteAccount}
            deleteChildAccount={this.props.deleteChildAccount}
            isSaving={this.props.isSavingChildUser}
            isChildEdit={true}
            error={this.props.error}
            senders={this.props.senders}
            isLoadingSenders={this.props.isLoadingSenders}
            orderContacts={this.props.orderContacts}
            isLoadingOrderContacts={this.props.isLoadingOrderContacts}
            postSender={this.props.postSender}
            deleteSender={this.props.deleteSender}
            isDeleting={this.props.isDeleting}
            isDeletingChildUser={this.props.isDeletingChildUser}
            isLoadingChildUser={this.props.isLoadingChildUser}
            isProxyLoginLoading={this.props.isProxyLoginLoading}
            postOrderContacts={this.props.postOrderContacts}
            deleteOrderContacts={this.props.deleteOrderContacts}
            isLoadingMails={this.props.isLoadingMails}
            mails={this.props.mails}
            postUserMails={this.props.postUserMails}
            patchChildUserAuthorityById={this.props.patchChildUserAuthorityById}
            deleteUserMailsById={this.props.deleteUserMailsById}
            patchUsersEmailNotificationFlag={this.props.patchUsersEmailNotificationFlag}
            postUsersUpdatePassword={this.props.postUsersUpdatePassword}
            proxyLoginChildUser={this.props.getProxyLoginChildUser}
          />
        );
      } else {
        return (
          <ChildAccountSetting
            childUsers={this.props.childUsers}
            goTo={this.props.goTo}
            isSaving={this.props.isSavingChildUser}
            isLoading={this.props.isLoadingChildUser}
            getChildUsers={this.props.getChildUsers}
          />
        );
      }
    } else if (this.state.childAccountTab === ChildAccountSettingDirectory.AUTHORITY.name) {
      return (
        <ChildAccountAuthoritySetting
          childUsers={this.props.childUsers}
          putChildUsersAuthority={this.props.putChildUsersAuthority}
          isSaving={this.props.isSavingChildUser}
          isLoading={this.props.isLoadingChildUser}
          goTo={this.props.goTo}
          user={user}
        />
      );
    } else if (this.state.childAccountTab === ChildAccountSettingDirectory.OWNER.name) {
      return (
        this.renderBody()
      )
    }
  }


  renderContent = () => {
    const { user } = this.props;
    if (this.state.tab === AccountSettingDirectory.GENERAL.value) {
      return (
        <BasicPanel
          user={user}
          setUserInfo={this.props.setUserInfo}
          deleteAccount={this.props.deleteAccount}
          isSaving={this.props.isSaving}
          error={this.props.error}
          senders={this.props.senders}
          isLoadingSenders={this.props.isLoadingSenders}
          orderContacts={this.props.orderContacts}
          isLoadingOrderContacts={this.props.isLoadingOrderContacts}
          postSender={this.props.postSender}
          deleteSender={this.props.deleteSender}
          isDeleting={this.props.isDeleting}
          postOrderContacts={this.props.postOrderContacts}
          deleteOrderContacts={this.props.deleteOrderContacts}
          isLoadingMails={this.props.isLoadingMails}
          mails={this.props.mails}
          postUserMails={this.props.postUserMails}
          deleteUserMailsById={this.props.deleteUserMailsById}
          patchUsersEmailNotificationFlag={this.props.patchUsersEmailNotificationFlag}
          postUsersUpdatePassword={this.props.postUsersUpdatePassword}
        />
      );
    } else if (this.state.tab === AccountSettingDirectory.PLANS.value) {
      return (
        <PlanPanel
          user={user}
          plans={user ? user.plans : {}}
        />
      );
    } else if (this.state.tab === AccountSettingDirectory.BILLING.value) {
      return (
        <BillingPanel
          paymentInfo={user ? user.user_payment : {}}
          updatePaymentInfo={this.props.updatePaymentInfo}
          postPaymentInfo={this.props.postPaymentInfo}
          isSaving={this.props.isSaving}
          error={this.props.error}
          routerInfo={this.props.routerInfo}
        />
      )
    } else if (this.state.tab === AccountSettingDirectory.INTEGRATIONS.value) {
      return (
        <IntegrationPanel
          user={user}
          integrations={user ? user.integrations : []}
          salesforceImportMapping={user ? user.salesforce_import_mapping : []}
          removeCrm={this.props.removeCrm}
          goTo={this.props.goTo}
          togglePlanDialog={this.togglePlanDialog}
        />
      )
    }
  }

  // 表示するタブ一覧を取得する（支払いタブは非表示）
  getVisibleTabValues = () => (
    Object.values(AccountSettingDirectory).filter(item => item.value !== AccountSettingDirectory.BILLING.value)
  );

  renderBody = () => {
    const { classes, user } = this.props;

    if (this.props.isLoading || !user) {
      return (
        <Loader type='color' />
      )
    } else {
      return (
        <div className={`${classes.content} ${user && user.ownership_authority_flag ? classes.ownerContent : classes.otherContent}`}>
          <FilterTabs
            value={this.state.tab}
            handleTabClicked={this.handleTabClicked}
            tabValues={this.props.user.user_role ? [AccountSettingDirectory.GENERAL] : this.getVisibleTabValues()} //子アカウントは基本のタブのみ表示
          />
          {this.renderContent()}
        </div>
      )
    }
  };

  render() {
    const { classes, user } = this.props;

    let notification, createChildAccountDialog, editAuthorityDialog;
    if (this.state.showNotification) { notification = this.renderNotification(); }
    if (this.state.showCreateChildAccountDialog) { createChildAccountDialog = this.renderCreateChildAccountDialog(); }

    return (
      <Wrapper className={classes.root}>
        <Header title="アカウント管理" type="dark" hasBackBtn={false} />
        {(() => {
          if (user && !!user.ownership_authority_flag) {
            return (
              <div className={classes.childContent}>
                <AccountSettingHeader
                  childAccountType={this.props.childAccountType}
                  goTo={this.props.goTo}
                  handleCsvExportAll={this.handleCsvExportAll}
                  toggleCreateChildAccountDialog={this.toggleCreateChildAccountDialog}
                  getCurrentTabTotal={this.getCurrentTabTotal}
                  limitUsage={this.props.limitUsage}
                  isDemo={this.props.showDemoData}
                />
                <div className={classes.content} style={{ margin: 'auto', display: 'block' }}>
                  {this.renderChildAccountContent()}
                </div>
              </div>
            )
          } else {
            return (
              this.renderBody()
            )
          }
        })()}
        {this.renderPlanDialog()}
        {notification}
        {createChildAccountDialog}
        {editAuthorityDialog}
      </Wrapper>
    );
  }
}

AccountSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  message: PropTypes.string,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  setUserInfo: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  updatePaymentInfo: PropTypes.func.isRequired,
  postPaymentInfo: PropTypes.func.isRequired,
  removeCrm: PropTypes.func.isRequired,
  updateRouterState: PropTypes.func.isRequired,
  routerInfo: PropTypes.object,
  type: PropTypes.number,
  childAccountType: PropTypes.string,
  getChildUsers: PropTypes.func.isRequired,
  childUsers: PropTypes.array,
  isSavingChildUser: PropTypes.bool,
  isLoadingChildUser: PropTypes.bool,
  isLoading: PropTypes.bool,
  deleteChildAccount: PropTypes.func.isRequired,
  deleteSender: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
  senders: PropTypes.array,
  isLoadingSenders: PropTypes.bool,
  postSender: PropTypes.func.isRequired,
  orderContacts: PropTypes.array,
  isLoadingOrderContacts: PropTypes.bool,
  postOrderContacts: PropTypes.func.isRequired,
  deleteOrderContacts: PropTypes.func.isRequired,
  mails: PropTypes.array,
  isLoadingMails: PropTypes.bool,
  postUserMails: PropTypes.func.isRequired,
  deleteUserMailsById: PropTypes.func.isRequired,
  patchUsersEmailNotificationFlag: PropTypes.func.isRequired,
  patchChildUserAuthorityById: PropTypes.func.isRequired,
  postUsersUpdatePassword: PropTypes.func.isRequired,
  isDeletingChildUser: PropTypes.bool,
  isProxyLoginLoading: PropTypes.bool,
  getProxyLoginChildUser: PropTypes.func.isRequired,
  limitUsage: PropTypes.number,
  showDemoData: PropTypes.bool,
  getUserInfo: PropTypes.func.isRequired,
  getSenders: PropTypes.func.isRequired,
  getOrderContacts: PropTypes.func.isRequired,
  getUserMails: PropTypes.func.isRequired,
  match: PropTypes.object,
  childUser: PropTypes.object,
  getChildUserById: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  postChildUser: PropTypes.func.isRequired,
  putChildUsersAuthority: PropTypes.func.isRequired,
};

export default withStyles(styles)(AccountSetting);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/AccountSetting.jsx